// FOUND-09: Stable version stamp surfaced on result panels.
import { rates2026 } from "./rates-2026";

const verifiedAt = rates2026.strom.haushaltsstrompreis_ct_kwh.verifiedAt;
export const RATES_VERSION = `rates-${rates2026.meta.jahr}.${verifiedAt}`;
